import {Component, EventEmitter, Input, Output} from "@angular/core";
import {DatePipe} from "@angular/common";
import {Cirf} from "../cirf";
import {
    CIRF_ADDITIONAL_TOPICS,
    CIRF_CLIENT_TOPICS,
    CIRF_NAME_KEYS,
    CIRF_OTHER_TOPICS,
    DpBooleanValueTypes, CIRF_NEW_MORTGAGE_NOTES_TOPICS, CIRF_EXISTING_MORTGAGE_NOTES_TOPICS
} from "../../shared/constants";
import {CirfClientInfo} from "../cirf-client-info";
import {CirfNavigation, NavigationSection} from "../cirf-navigation";

@Component({
    selector: 'dp-cirf-side-nav',
    templateUrl: './cirf-side-nav.component.html',
    providers: [DatePipe]
})
export class CirfSideNavComponent {

    @Input() cirf : Cirf;
    @Input() cirfNavigation: CirfNavigation;
    @Input() isCirfSubmitted: boolean;
    @Output() selectSection = new EventEmitter();
    @Output() addNewMortgage = new EventEmitter();
    @Output() addExistingMortgage = new EventEmitter();
    @Output() addClient = new EventEmitter();


    cirfClientTopics = CIRF_CLIENT_TOPICS;
    cirfOtherTopics = CIRF_OTHER_TOPICS;
    cirfNewMortgageNotes = CIRF_NEW_MORTGAGE_NOTES_TOPICS;
    cirfExistingMortgageNotes = CIRF_EXISTING_MORTGAGE_NOTES_TOPICS;
    cirfAdditionalNotes = CIRF_ADDITIONAL_TOPICS;

    isInsuranceApplicable() : boolean {
        return this.cirf && this.cirf.isInsuranceApplicable();
    }

    isTransactionDetailApplicable(topicKey: string): boolean {
        return !this.cirf?.isWillMatter() && topicKey === 'TRANSACTION_DETAILS';
    }

    isSectionVisible(section) : boolean {
        return !(section.sectionKey==CIRF_NAME_KEYS.newInsuranceDetails.key && !this.isInsuranceApplicable());
    }

    isClientSectionVisible(clientInfo: CirfClientInfo, section: any) : boolean {
        if(clientInfo.isAgreedToUploadDLNo()){
            return true;
        } else {
            return clientInfo.showAllFields || section.sectionKey==CIRF_NAME_KEYS.personalDetails.key;
        }
    }

    onOtherTopicSelection(topicKey: string, sectionKey: string) {
        let clientIndex = sectionKey == CIRF_NAME_KEYS.clientNotes.key ? 0 : -1;
        this.onSelectSection(clientIndex, topicKey, sectionKey, undefined,-1, -1 , );
    }

    onSelectSection(clientIndex: number, topicKey: string, sectionKey: string, clientInfo: CirfClientInfo ,newMortgageIndex?: number, existingMortgageIndex?: number) : void {
        let navigationSection = new NavigationSection();
        navigationSection.clientIndex = clientIndex >=0 ? clientIndex : -1;
        navigationSection.topicKey = topicKey;
        navigationSection.sectionKey = sectionKey;
        navigationSection.existingMortgageIndex = existingMortgageIndex >=0 ? existingMortgageIndex : -1;
        navigationSection.newMortgageIndex = newMortgageIndex >=0 ? newMortgageIndex : -1;
        this.selectSection.emit({navigationSection: navigationSection});
    }


    onAddNewMortgage() : void {
        this.addNewMortgage.emit();
    }

    onAddExistingMortgage() : void {
        this.addExistingMortgage.emit();
    }

    addNewClient() : void {
        this.addClient.emit();
    }

    get clients() : CirfClientInfo[] {
        return this.cirf ? this.cirf.cirfClients : [];
    }

    isSectionReviewSubmit(sectionKey: string) : boolean {
        return sectionKey == CIRF_NAME_KEYS.reviewSubmit.key;
    }

    isTopicClientNotes(topicKey: string) : boolean {
        return topicKey == CIRF_NAME_KEYS.clientNotesTopic.key;
    }

    isExistingAccessNavSection(clientIndex: number, sectionKey?: string, newMortgageIndex?: number, existingMortgageIndex?:number) : boolean {
        let navigationSection: NavigationSection = new NavigationSection();
        navigationSection.clientIndex = clientIndex;
        navigationSection.sectionKey = sectionKey;
        navigationSection.newMortgageIndex = newMortgageIndex;
        navigationSection.existingMortgageIndex = existingMortgageIndex;
        return this.cirf.cirfMatterData.findExistingAccessNavSection(navigationSection) || !!this.isCirfSubmitted;
    }

    isSectionHasErrors(clientIndex: number, sectionKey?: string, newMortgageIndex?: number, existingMortgageIndex?:number) : boolean {
         if(clientIndex >=0) {
            let client = this.cirf.cirfMatterData.cirfClients[clientIndex];
            switch(sectionKey){
                case CIRF_NAME_KEYS.personalDetails.key : return client.hasPersonalDetailsSectionErrors;
                case CIRF_NAME_KEYS.contactDetails.key : return client.hasContactDetailsSectionErrors;
                case CIRF_NAME_KEYS.idVerification1.key : return client.hasIdVerification1SectionErrors;
                case CIRF_NAME_KEYS.idVerification2.key : return client.hasIdVerification2SectionErrors;
            }
            return client && client.hasErrors;
        }
        if(newMortgageIndex >= 0){
            let mortgage = this.cirf.cirfMatterData.newMortgages[newMortgageIndex];
            return mortgage && mortgage.hasErrors;
        }
        if(existingMortgageIndex >= 0){
            let mortgage = this.cirf.cirfMatterData.existingMortgage[existingMortgageIndex];
            return mortgage && mortgage.hasErrors;
        }
        if(sectionKey == CIRF_NAME_KEYS.matterContactInfo.key) {
            return this.cirf?.matterContactInfo?.hasErrors;
        }

        if(sectionKey == CIRF_NAME_KEYS.newInsuranceDetails.key) {
            return this.cirf?.fireInsuranceDetail?.hasErrors;
        }

        return false;
    }

}
